class Config {

    //状态 1.待执行 2.处理中 3.执行成功 4.执行失败
    static STATUS_WAIT = 1
    static STATUS_PROCESS = 2
    static STATUS_SUCCESS = 3
    static STATUS_ERROR = 4
}

export default Config